export default class Address {
  static formatAddress (address) {
    const { route, number, complement, district, city, state } = address
    return `${route}, ${number}${complement ? `, ${complement}` : ''} - ${district}, ${city} - ${state}`
  }

  static formatAddressWithNoComplement (address) {
    const { route, number, district, city, state } = address
    const formattedAddress = `${route}, ${number} - ${district}, ${city} - ${state}`

    return formattedAddress
  }

  static formatCep (cep) {
    if (!cep) return ''
    const digits = cep.toString ().replace (/\D/g, '').padStart (8, '0')
    return `${digits.slice (0, 5)}-${digits.slice (5, 8)}`
  }
}
